var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { RecordLink } from "../style/globalPropertiesPanel.style";
import { getEntityLabel } from "../../../constants/properties.constants";
var rowId = function (row) { var _a; return (_a = row.propertyId) !== null && _a !== void 0 ? _a : "".concat(row.entity, ":").concat(row.entityId, ":").concat(row.name); };
export var useGlobalPropertiesPanel = function (props) {
    var rowsById = useMemo(function () {
        var map = {};
        props.rows.forEach(function (row) {
            map[rowId(row)] = row;
        });
        return map;
    }, [props.rows]);
    var columns = [
        { key: "entity", header: "Entidad", tag: true, width: "12%" },
        {
            key: "record",
            header: "Registro",
            width: "26%",
            render: function (row) {
                var source = rowsById[row.id];
                if (!source)
                    return row.values.record;
                return (_jsx(RecordLink, __assign({ onClick: function () { return props.onGoToRecord(source.entity, source.entityId); } }, { children: source.recordLabel })));
            },
        },
        { key: "name", header: "name", editable: props.canEdit, width: "28%" },
        { key: "value", header: "value", editable: props.canEdit, width: "34%" },
    ];
    var rows = props.rows.map(function (row) { return ({
        id: rowId(row),
        values: {
            entity: getEntityLabel(row.entity),
            record: row.recordLabel,
            name: row.name,
            value: row.value,
        },
    }); });
    var onSaveRow = function (row, values) {
        var _a, _b;
        var source = rowsById[row.id];
        if (!source)
            return;
        props.onSave(source, (_a = values.name) !== null && _a !== void 0 ? _a : source.name, (_b = values.value) !== null && _b !== void 0 ? _b : source.value);
    };
    return { columns: columns, rows: rows, onSaveRow: onSaveRow };
};
